/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/**
 * Format the address to a human-readable format
 * like "[streetName] [streetNumber], [zip] [locality]"
 * or "[streetName], [zip] [locality]"
 * or "[locality]"
 * @param result
 * @returns {*}
 */
function formatAddress(result) {
  let address = ''

  if (result.streetName && result.streetNumber) {
    address += `${result.streetName} ${result.streetNumber}, ${result.postalCode} ${result.locality}`
  }

  else if (result.streetName) {
    address += `${result.streetName}, ${result.postalCode} ${result.locality}`
  }

  else if (result.postalCode) {
    address += `${result.locality} (${result.postalCode})`
  }

  else {
    address += `${result.locality}`
  }

  if (result.country) {
    address += `, ${result.country}`
  }

  return address
}

jQuery(document).ready(function ($) {
  const $addressInput = $('.filter-reasonable-filter-field__address input[type="text"]')

  $addressInput.on('focus', function () {
    $(this).autocomplete('search', $(this).val())
  })

  $addressInput.autocomplete({
    minLength: 2,
    select: function (event, ui) {
      $addressInput.val(ui.item.value).trigger('change').blur()
      // $('.filter-reasonable-filter-field__address').trigger('address-selected')
    },
    source: function ( request, response ) {
      // const country = $('select[name="country"]').val()
      // let term = request.term
      // if (country === 'DE') {
      //   term += ', Deutschland'
      // }

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        method: 'POST',
        data: {
          action: 'get_places_autocomplete_results',
          address: request.term
        },
        success: function (data) {
          data = data.filter(x => !!x.locality)

          data.forEach((result) => {
            // add a unique id to the result
            result.label = formatAddress(result)
          })

          // remove duplicates
          data = data.filter((v, i, a) => a.findIndex(t => (t.label === v.label)) === i)

          // store the results in the input
          $addressInput.data('results', data)

          // update the autocomplete source
          response(data.map((x) => x.label))
        },
        error: function () {
          response([])
        },
      })
    }
  })

  $addressInput.on('change', function () {
    if ($addressInput.val()) {
      $addressInput.closest('.filter-reasonable-filter-field').find('.filter-reasonable-filter-field__reset-location-button').show();
    } else {
      $addressInput.closest('.filter-reasonable-filter-field').find('.filter-reasonable-filter-field__reset-location-button').hide();
    }

    const $message = $(this).closest('.filter-reasonable-filter-field__address')
      .find('.filter-reasonable-filter-field__message')

    $message.text('')

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: {
        action: 'get_geocoding_results',
        address: $addressInput.val()
      },
      success: function (response) {
        const firstLocation = response[0]

        if (firstLocation) {
          $message.text(formatAddress(firstLocation))
        }
      },
      error: function () {
        $message.text('Keine Adresse gefunden')
      }
    })
  })

  $addressInput.closest('.filter-reasonable-filter-field').find('.filter-reasonable-filter-field__reset-location-button').on('click', function () {
    $addressInput.val('').trigger('change')
  });

  if ($addressInput.val()) {
    $addressInput.closest('.filter-reasonable-filter-field').find('.filter-reasonable-filter-field__reset-location-button').show();
  }

  // clear the input, lat and lng on button click
  // $addressInput.siblings('button').on('click', function () {
  //   $addressInput.val('')
  //   $addressInput.siblings('input').val('')
  //   $addressInput.trigger('address-selected')
  // })
  //
  // $addressInput.autocomplete({
  //   minLength: 0,
  //   source: [],
  //   select: function (event, ui) {
  //     const $form = $addressInput.closest('form')
  //
  //     $addressInput.val(ui.item.value)
  //
  //     const $result = $addressInput.data('results').find((result) => result.label === ui.item.label)
  //     if ($result) {
  //       $form.find('input[name="lat"]').val($result.latitude)
  //       $form.find('input[name="lng"]').val($result.longitude)
  //     }
  //
  //     // unfocus the input
  //     $addressInput.blur()
  //
  //     $addressInput.trigger('address-selected')
  //   }
  // })

  const addressInputHandler = filterReasonableDebounce(function (e) {
    e.preventDefault()

    const $form = $addressInput.closest('form')

    const $latInput = $form.find('input[name="lat"]')

    // if the lat input is already filled, don't do anything
    if ($latInput.val()) {
      $addressInput.autocomplete('option', 'source', [])
      return
    }

    const $formData = $form.serialize()

    // disable the input
    $addressInput.prop('disabled', true)

    // add bootstrap spinner class to the form
    $('.filter-reasonable-filter-box__spinner').addClass('filter-reasonable-filter-box__spinner--active');

    $.ajax({
      url: '/wp-admin/admin-ajax.php?' + $formData,
      method: 'POST',
      data: {
        action: 'get_geocoding_results'
      },
      /**
       * example response:
       * [
       *     {
       *         "providedBy": "nominatim",
       *         "latitude": 52.510885,
       *         "longitude": 13.3989367,
       *         "bounds": {
       *             "south": 52.3382448,
       *             "west": 13.088345,
       *             "north": 52.6755087,
       *             "east": 13.7611609
       *         },
       *         "streetNumber": null,
       *         "streetName": null,
       *         "postalCode": null,
       *         "locality": "Berlin",
       *         "subLocality": null,
       *         "adminLevels": [],
       *         "country": "Deutschland",
       *         "countryCode": "DE",
       *         "timezone": null
       *     }
       * ]
       * @param response
       */
      success: function (response) {
        response = response.filter(x => !!x.locality)

        response.forEach((result) => {
          // add a unique id to the result
          result.label = formatAddress(result)
        })

        // remove duplicates
        response = response.filter((v, i, a) => a.findIndex(t => (t.label === v.label)) === i)

        // store the results in the input
        $addressInput.data('results', response)

        // update the autocomplete source
        $addressInput.autocomplete('option', 'source', response.map((x) => x.label))

        // if only one result, select it
        if (response.length === 1) {
          $addressInput.val(response[0].label)
          $form.find('input[name="lat"]').val(response[0].latitude)
          $form.find('input[name="lng"]').val(response[0].longitude)

          // unfocus the input
          $addressInput.blur()

          $addressInput.trigger('address-selected')
        }
        else {
          // open the autocomplete
          $addressInput.autocomplete('search', '')

          $('.filter-reasonable-filter-box__spinner').removeClass('filter-reasonable-filter-box__spinner--active');
        }

        $addressInput.removeAttr('disabled')
      },
      error: function () {
        $('.filter-reasonable-filter-box__spinner').removeClass('filter-reasonable-filter-box__spinner--active');

        $addressInput.removeAttr('disabled')
      },
    })
  }, 500)

  // listen for changes with debounce
  // $addressInput.on('input', addressInputHandler)
  // $addressInput.on('keydown', function (e) {
  //   if (e.key === 'Enter') {
  //     e.preventDefault()
  //     addressInputHandler(true, e)
  //   }
  // })

  $('.filter-reasonable-filter-field__dropdown-button').on('click', function() {
    const $control = $(this).closest('.filter-reasonable-filter-field__dropdown-control');

    const stillOpenDropdowns = $('.filter-reasonable-filter-field__dropdown--active').not($control);
    if (stillOpenDropdowns.length) {
      stillOpenDropdowns.removeClass('filter-reasonable-filter-field__dropdown--active');
    }

    const filterReasonableDropdownClickHandler = (e) => {
      // check if click hits outside the dropdown
      if (!$(e.target).closest('.filter-reasonable-filter-field__dropdown-control ul, .filter-reasonable-filter-field__dropdown-wrapper').length) {
        // hide the dropdown
        $control.removeClass('filter-reasonable-filter-field__dropdown--active');
        $(window).off('click', filterReasonableDropdownClickHandler);
      }
    }

    if ($control.hasClass('filter-reasonable-filter-field__dropdown--active')) {
      $control.removeClass('filter-reasonable-filter-field__dropdown--active');
      window.requestAnimationFrame(() => {
        $(window).off('click', filterReasonableDropdownClickHandler);
      });
    } else {
      $control.addClass('filter-reasonable-filter-field__dropdown--active');
      window.requestAnimationFrame(() => {
        $(window).on('click', filterReasonableDropdownClickHandler);
      });
    }
  });

  // find change event on select box
  $('.filter-reasonable-filter-field__relation-switch').on('change', function() {
    const $field = $(this).closest('.filter-reasonable-filter-field');
    // get the selected value of the select box
    const value = $(this).find('option:selected').val();
    $field.attr('data-filter-mode', String(value).toLowerCase());
  });

  $('.filter-reasonable-filter-field__show-more-button, .filter-reasonable-filter-field__show-less-button').on('click', function(e) {
    e.preventDefault();
    const $field = $(this).closest('.filter-reasonable-filter-field');
    // toggle class filter-reasonable-filter-field__hidden-terms--active
    $field.toggleClass('filter-reasonable-filter-field__hidden-terms--active');
  });

  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});